



















































































































































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import SearchFilter from '../Utilities/SearchFilter.vue';
import EmergencyContact from '../EmergencyContact.vue';
import moment from 'moment';

@Component({
    components: {
        SearchFilter,
        EmergencyContact
    }
})

export default class EmergencyContactPage extends Vue {
    filterSelected: boolean = false;
    username: string = null;
    freeTextFilter: string = "";
    usernameFilter: string = "";
    nameFilter: string = "";
    surnameFilter: string = "";
    emailFilter: string = "";
    firstSearch: boolean = false;
    showLoading: boolean = false;
    usernameSelected = null;
    idUserCountrySelected: string = null;
    advOnlyPending: boolean = null;
    advOnlyConfirmedTel: boolean = null;
    advOnlyAcceptedPrivacy: boolean = null;
    radioSelected: string = '0';

    users = null;
    user = null;

    optionsCountry: any = new Array();
    countryFilter: any = null;

    page: number = 1;
    resultsItems: any = {
        resultPage: new Array(),
        total: 0
    };
    formatDate(value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }

    searchFilterSearchEvent(genericSearch: string) {
        this.freeTextFilter = genericSearch
        this.searchItems(true)
    }

    resetSearch() {
        this.users = new Array();
        this.resultsItems.resultPage = new Array();
        this.page = 1;
    }

    searchFilterResertEvent() {
        this.nameFilter = "";
        this.emailFilter = "";
        this.surnameFilter = "";
        this.usernameFilter = "";
        this.freeTextFilter = "";
        this.filterSelected = false;
        this.radioSelected = '0';
        this.countryFilter = null;
    }

    checkFilterParameter() {
        if (this.checkFilters()) {
            this.filterSelected = true;
        }
        else {
            this.filterSelected = false;
        }
    }
    checkFilters() {
        if (!this.CheckIsNullOrEmpty(this.nameFilter)) return true
        if (!this.CheckIsNullOrEmpty(this.usernameFilter)) return true
        if (!this.CheckIsNullOrEmpty(this.surnameFilter)) return true
        if (!this.CheckIsNullOrEmpty(this.emailFilter)) return true
        return false
    }

    CheckIsNullOrEmpty(text: string) {
        if (text == null) return true;
        if (text == '') return true;
        return false;
    }

    async GetAssigendCountries(){
        try{
            let result: any = await axios({
                method:'get',
                url:General.GetApiUrl('/api/Culture/GetAssigendCountries'),
                withCredentials:true,
                responseType: 'json',
            })
            
            this.optionsCountry = result.data;
            this.optionsCountry.unshift({ idCountry: null, name: '' });
        }catch(error){
            General.HandleError(error, this);
        }
    }

    async searchItems(start: boolean) {

        this.showLoading = true;
        if (start == true)
            this.resetSearch();
        try {
            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/EmergencyContact/GetAllUsersWithEmergencyContacts'),
                data: {
                    FreeText: this.freeTextFilter,
                    Username: this.usernameFilter,
                    Name: this.nameFilter,
                    Surname: this.surnameFilter,
                    Email: this.emailFilter,
                    CurrentPage: this.page,
                    IsPending: parseInt(this.radioSelected) == 1 ? true : null,
                    IsTelConfirmed: parseInt(this.radioSelected) == 2 ? true : null,
                    IsPrivacyOpened: parseInt(this.radioSelected) == 3 ? true : null,
                    IsActive: parseInt(this.radioSelected) == 4 ? true : null,
                    IdCountry: this.countryFilter
                },
                withCredentials: true,
                responseType: 'json'
            });
            this.resultsItems.resultPage = this.resultsItems.resultPage.concat(results.data.listPage);
            this.resultsItems.total = results.data.total;
            this.firstSearch = true;
            this.page += 1;

            this.showLoading = false;
        } catch (error) {
            this.showLoading = false;
            General.HandleError(error, this);
        }
    }


    openModal(user) {
        this.usernameSelected = user.username;
        this.idUserCountrySelected = user.country.idCountry;
        this.$bvModal.show('bv-modal-emergency-info');
    }

    mounted(){
        this.GetAssigendCountries()
    }
}
